'use client'
import React, {
  useCallback,
  useState,
  FunctionComponent,
  PropsWithChildren,
  ReactElement,
  MouseEventHandler,
  useRef,
} from 'react'
import cn from 'classnames'
import { Icon } from '@/icons'
import { useClickOutside } from '@/hooks/clickOutside'

import styles from './DropDown.module.scss'

type DropDownProps = {
  className?: string
  buttonClassName: string
  buttonContent: string | ReactElement<any>
}
export const DropDown: FunctionComponent<PropsWithChildren<DropDownProps>> = ({
  className,
  buttonClassName,
  buttonContent,
  children,
}) => {
  const [isVisible, setIsVisible] = useState<boolean>(false)
  const contentRef = useRef<HTMLDivElement>(null)

  const toggle: MouseEventHandler<HTMLButtonElement> = useCallback((event) => {
    event.stopPropagation()
    event.nativeEvent.stopImmediatePropagation()
    setIsVisible((v) => !v)
  }, [])

  const hide = useCallback((e: any) => {
    if (!contentRef.current?.contains(e.target)) {
      setIsVisible(false)
    }
  }, [])

  useClickOutside(hide)

  return (
    <div className={cn(className, styles.container)}>
      <button className={cn(styles.button, buttonClassName)} onClick={toggle}>
        {buttonContent}
        <Icon
          name="selectArrow"
          className={cn(styles.arrow, {
            [styles.opened]: isVisible,
          })}
        />
      </button>
      <div
        ref={contentRef}
        className={cn(styles.children, {
          [styles.isVisible]: isVisible,
        })}
      >
        {children}
      </div>
    </div>
  )
}
